<template>
  <el-dialog
    :title="$t('showPartnerLog.accessLog')"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose">
    <el-form label-position="left" label-width="120px">
      <el-form-item :label="$t('showPartnerLog.requestMessage')">
        <el-input
          type="textarea"
          :rows="10"
          v-model="showPartnerLogInfo.reqParam"
          readonly>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('showPartnerLog.responseMessage')">
        <el-input
          type="textarea"
          :rows="10"
          v-model="showPartnerLogInfo.resParam"
          readonly>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('showPartnerLog.cancel')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getPartnerLogParam } from '@/api/partner/partnerLogApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShowPartnerLog',
  data() {
    return {
      dialogVisible: false,
      showPartnerLogInfo: {
        logId: '',
        reqParam: '',
        resParam: ''
      }
    }
  },
  methods: {
    open(log) {
      this.showPartnerLogInfo = { ...log }
      this.loadShowPartnerLogInfo()
      this.dialogVisible = true
    },
    handleClose(done) {
      this.clearShowPartnerLogInfo()
      done()
    },
    async loadShowPartnerLogInfo() {
      try {
        const res = await getPartnerLogParam({
          page: 1,
          row: 1,
          logId: this.showPartnerLogInfo.logId,
          shopId: getShopId()
        })
        if (res.data && res.data.length > 0) {
          this.showPartnerLogInfo = { ...res.data[0] }
        }
      } catch (error) {
        console.error(error)
      }
    },
    clearShowPartnerLogInfo() {
      this.showPartnerLogInfo = {
        logId: '',
        reqParam: '',
        resParam: ''
      }
    }
  }
}
</script>